import { Button, Input, Pagination, Space, Table, Tag, Typography } from "antd";
import { IconEdit } from "Common/ReactIcons";
import { IconSearch } from "Common/ReactIcons";
import { connect } from "react-redux";
import "./UserManagement.scss";
import AutoCompleteDebounce from "Components/AutoCompleteDebounce";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import api from "utils/api";
import moment from "moment";
import AddNewUser from "./AddNewUser";
import utils from "utils";
import { UserOutlined, InfoCircleOutlined } from "@ant-design/icons";
import ExportButton from "../ExportButtonSuperAdmin";

const UserManagement = (props) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [searchOptions, setSearchOptions] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [filters, setFilters] = useState({
    speciality: null,
    status: null,
  });
  const [issearchLoading, setIsSearchLoading] = useState(false);
  const history = useHistory();

  const fetchData = async (params = {}) => {
    setLoading(true);
    const { searchValue, filters, pagination } = params;

    const query = new URLSearchParams({
      search: searchValue.key || "",
      role: filters.role || "",
      status: filters.status || "",
      page: pagination.current || 1,
      page_size: pagination.pageSize || 10,
    }).toString();

    try {
      const response = await api.get_management_list(query);
      if (response.data.status === 200 && response.data.message === "success") {
        const { results, count } = response.data.data;
        const transResult = results.map((item, index) => ({
          ...item,
          key: index,
        }));
        setData(transResult);
        setPagination({ ...pagination, total: count });
      } else {
        console.error("Failed to fetch data: unexpected response format");
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setLoading(false);
    }
  };
  // useEffect(() => {
  //   // fetchSpecialityOptions();
  //   fetchData({ searchValue, filters, pagination });
  // }, [searchValue, filters, pagination.current, pagination.pageSize]);

  const handleTableChange = (Pagination, Filters) => {
    // setPagination(Pagination);
    setFilters(Filters);
  };
  useEffect(() => {
    setPagination((prev) => ({ ...prev, current: 1, pageSize: 10 }));
    fetchData({
      searchValue,
      filters,
      pagination: { current: 1, pageSize: 10 },
    });
  }, [searchValue, filters]);
  const handleSearchChange = async (value) => {
    if (value) {
      setIsSearchLoading(true);
      try {
        const query = new URLSearchParams({ search: value }).toString();
        const response = await api.get_user_name_suggestion(query);

        if (
          response.data.status === 200 &&
          response.data.message === "success"
        ) {
          const { results } = response.data.data;
          const options = [];

          results.forEach((result) => {
            Object.keys(result).forEach((key) => {
              // Wrap each iteration into the specified structure
              const entry = {
                key: key,
                label: (
                  <span>
                    {key
                      .replace(/_/g, " ")
                      .replace(/\b\w/g, (c) => c.toUpperCase())}
                  </span>
                ),
                options: [],
              };

              // Continue with the logic if the value is an array
              if (Array.isArray(result[key])) {
                result[key].forEach((item) => {
                  entry.options.push({
                    value: item[key === "name" ? "user_name" : key],
                    label: (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {item[key === "name" ? "user_name" : key]}
                        <span>
                          <UserOutlined />{" "}
                          {key === "email" ? item.user_name : item.email}
                        </span>
                      </div>
                    ),
                    key: item.user_id,
                  });
                });
              }

              // Add the entry to the options array
              if(entry.options.length>0){
              options.push(entry);}
            });
          });

          setSearchOptions(options);
        } else {
          console.error("Failed to fetch data: unexpected response format");
        }
      } catch (error) {
        console.error("Failed to fetch search options:", error);
      } finally {
        setIsSearchLoading(false);
      }
    } else {
      setSearchValue("");
      setSearchOptions([]);
    }
  };
  const getStatusTag = (status) => {
    let color = "";
    switch (status) {
      case "Active":
        color = "#4AB915";
        break;
      case "In Active":
        color = "#A60000";
        break;
      default:
        color = "#4AB915";
        break;
    }
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          color: color,
          gap: "8px",
        }}
      >
        <div
          style={{
            backgroundColor: color,
            width: "8px",
            height: "8px",
            borderRadius: "50%",
          }}
        ></div>
        <div>{status}</div>
      </div>
    );
  };
  const columns = [
    {
      title: "NAME",
      dataIndex: "name",
      key: "name",
      width: 200,
    },
    {
      title: "CONTACT INFO",
      key: "email",
      width: 200,
      render: (text, record) => (
        <div>
          <div>{`${record.country_code}${record.mobile_number}`}</div>
          <div>{record.email}</div>
        </div>
      ),
    },
    {
      title: "ROLE",
      dataIndex: "role",
      key: "role",
      width: 150,
      filters: [
        { text: "Doctor", value: "doctor" },
        { text: "Care Admin", value: "care_admin" },
        { text: "Super Admin", value: "super_admin" },
      ],
      render: (text, record) => (
        <>
          <div>{text}</div>
          {record.role == "Doctor" && (
            <a
              onClick={() => {
                history.push(
                  `${props.user_details.baseUrl}/clinician-check-availability`,
                  {
                    doctor_id: record.user_id,
                    ...record,
                  }
                );
              }}
            >
              <span>Check Availability</span>
            </a>
          )}
        </>
      ),
    },
    {
      title: "STATUS",
      dataIndex: "status",
      key: "status",
      width: 150,
      filters: [
        { text: "Active", value: "Active" },
        { text: "In Active", value: "In Active" },
      ],
      render: (text, record) => getStatusTag(record.status),
    },
    {
      title: "LAST LOGIN",
      dataIndex: "last_login",
      key: "last_login",
      width: 150,
      render: (text, record) => {
        const { last_login } = record;
        if (!last_login) {
          return <div>-</div>;
        }
        return (
          <>
            <div>{moment(record.last_login).format("MMM DD, YYYY")}</div>
            <div>{moment(record.last_login).format("h:mm A")}</div>
          </>
        );
      },
    },
    {
      title: " ",
      key: "action",
      width: 150,
      render: (text, record) => (
        // <div
        //   style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}
        // >
        <Button
          type="link"
          icon={<IconEdit />}
          onClick={() => {
            history.push(`${props.user_details.baseUrl}/edit-user`, {
              user_id: record.user_id,
            });
          }}
        />
        //   <Button
        //     type="link"
        //     // icon={<IconEdit />}
        //     onClick={() => {
        //       history.push(`${props.user_details.baseUrl}/clinician-check-availability`, {
        //         doctor_id: record.doctor_id,...record,
        //       });
        //     }}
        //   ><span>Check Availability</span></Button>
        // </div>
      ),
    },
  ];
  return (
    <div className="clinician-table">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <div style={{ display: "flex", alignItems: "flex-start" }}>
          <AutoCompleteDebounce
            options={searchOptions}
            style={{ padding: "0px 24px 0px 16px" }}
            onSelect={(value, option) => setSearchValue(option)}
            onSearch={handleSearchChange}
            loading={issearchLoading}
          >
            <Input
              prefix={<IconSearch />}
              style={{ height: "100%", width: "412px" }}
              placeholder="Search by Name/Contact No./Email."
            />
          </AutoCompleteDebounce>
        </div>
        <div style={{ display: "flex", gap: "16px", alignItems: "end" }}>
          <ExportButton />
          <Button
            style={{ background: "rgb(18, 0, 95)", color: "white" }}
            onClick={() => {
              utils.Modal(true, {
                content: (
                  <AddNewUser
                    submitButtonAction={() => {
                      utils.Modal(false);
                      fetchData({
                        searchValue,
                        filters,
                        pagination: { current: 1, pageSize: 10 },
                      });
                    }}
                  />
                ),
                width: "752px",
                closable: false,
              });
            }}
          >
            Add User
          </Button>
        </div>
      </div>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        onChange={handleTableChange}
        rowKey="key"
        pagination={false}
        scroll={{
          x: "max-content",
          // y:"70vh"
        }}
        className="clinician-table"
        // tableLayout="fixed"
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <Pagination
          current={pagination.current || 1}
          pageSize={pagination.pageSize || 10}
          pageSizeOptions={[5, 10, 15, 20, 50, 100]}
          total={pagination.total}
          showSizeChanger
          showTotal={(total) => `Total ${pagination.total} items`}
          onChange={(current, pageSize) => {
            setPagination((prev) => ({ ...prev, current, pageSize }));
            fetchData({
              searchValue,
              filters,
              pagination: { current, pageSize },
            });
          }}
        />
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    user_details: state.loginReducer?.user_details,
  };
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(UserManagement);
